import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Computer, ListResponse } from '@/types';
import { truncate } from '@/utils/truncate';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteComputer, UpdateComputer } from '../components';

export interface ComputerListProps {
  list?: ListResponse<Computer>;
  page: number;
  onChangePage(page: number): void;
}

const ComputersTable: React.FC<ComputerListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentComputer, setCurrentComputer] = useState<Computer | null>(null);

  function openUpdateModal(computer: Computer) {
    setCurrentComputer(computer);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(computer: Computer) {
    setCurrentComputer(computer);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Код</TableCell>
                <TableCell />
                <TableCell>Комментарий</TableCell>
                <TableCell>Точка</TableCell>
                <TableCell>Scaner port type</TableCell>
                <TableCell>Sensitivity</TableCell>
                <TableCell>VPN IP</TableCell>
                <TableCell>VPN Username</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((computer) => {
                const { code, comment, point, scaner_port_type, sensitivity, vpn_ip, vpn_username, id } = computer;

                return (
                  <TableRow key={id}>
                    <TableCell>{code}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(computer)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(computer)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>

                    <TableCell>{truncate(comment, 40)}</TableCell>
                    <TableCell>{point?.name ?? '—'}</TableCell>
                    <TableCell>{scaner_port_type}</TableCell>
                    <TableCell>
                      <Tooltip title={sensitivity ? 'Активно' : 'Неактивно'}>
                        <Switch checked={Boolean(sensitivity)} readOnly />
                      </Tooltip>
                    </TableCell>
                    <TableCell>{vpn_ip}</TableCell>
                    <TableCell>{vpn_username}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateComputer
        computer={currentComputer!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteComputer
        computer={currentComputer!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default ComputersTable;
